/* eslint-disable */ // --> OFF - while we fix this file
var player; //eslint-disable-line
var Howitwork;
var audioDescription; //eslint-disable-line
var volumeButton;
var open = false;
var volumeButtonClick = false;

document.addEventListener( "DOMContentLoaded", activateHowItWorks, false );
function activateHowItWorks(){
  // overlay = document.querySelector('.overlay-nav');
  $("#d-howitwork").click(function () {
    document.getElementById("video-container-body").style.display = "block";
    toggleVolumeHowitwork("open");
    open = true; //eslint-disable-line
  });

  // $("#maf-sidebar-howitworks").click(function () {
  //   document.getElementById("video-container-body").style.display = "block";
  //   toggleVolumeHowitwork("open");
  //   // $("#sidebar").offcanvas("hide");
  //   document.body.style.overflow = "hidden";
  //   var navbar = document.getElementById("maf-global-navbar");
  //   navbar.style.zIndex = "0";
  //   open = true; //eslint-disable-line
  //   document.documentElement.scrollTop = 0; // For modern browsers
  //   document.body.scrollTop = 0; // For older browsers
  // });
}

function toggleVolumeHowitwork(item) {
  //eslint-disable-line
  //eslint-disable-line
  var isMobileView = window.innerWidth <= 960;
  volumeButton = document.getElementById("volume-button-howitwork");
  var video = document.getElementById("howitwork");
  if (item == "open") {
    document.getElementById("video-container-body").style.display = "block";
    document.getElementById("video-container-body").classList.add("visible");
  } else {
    document.getElementById("video-container-body").style.display = "none";
    document.getElementById("video-container-body").classList.remove("visible");
  }
  var close = document.getElementById("close-button-howitwork");
  var videoId = document.getElementById("video-container-howitwork");
  close.style.display = "block";
  close.style.zIndex = "999999";
  videoId.style.zIndex = "999999";
  videoId.style.position = "fixed";
  if (isMobileView) {
    videoId.style.top = "0";
    videoId.style.width = "100%";
    videoId.style.height = "100%";
    video.style.borderRadius = "0";
  } else {
    video.style.borderRadius = "24px";
    var videoWidth = window.innerWidth >= 1260;
    var videoHeight = window.innerHeight >= 800;
    videoId.style.top = "50%";
    videoId.style.marginTop = "20px";
    videoId.style.left = "50%";
    videoId.style.transform = "translate(-50%, -50%)";
    if (videoWidth && videoHeight) {
      videoId.style.width = "1176px";
      videoId.style.height = "662px";
    } else {
      videoWidth = 1176; // Width of the video
      videoHeight = 662; // Height of the video
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // Calculate the aspect ratio of the video
      var aspectRatio = videoWidth / videoHeight;

      var newWidth, newHeight;

      // Determine the maximum dimensions based on covering 80% of the screen
      var maxScreenWidth = windowWidth * 0.6;
      var maxScreenHeight = windowHeight * 0.6;

      // Determine which dimension (width or height) needs to be adjusted
      if (maxScreenWidth / maxScreenHeight > aspectRatio) {
        // Adjust based on width
        newWidth = Math.min(maxScreenWidth, videoWidth);
        newHeight = newWidth / aspectRatio;
      } else {
        // Adjust based on height
        newHeight = Math.min(maxScreenHeight, videoHeight);
        newWidth = newHeight * aspectRatio;
      }

      // Ensure the dimensions do not exceed the original video dimensions
      newWidth = Math.min(newWidth, videoWidth);
      newHeight = Math.min(newHeight, videoHeight);

      videoId.style.width = newWidth + "px";
      videoId.style.height = newHeight + "px";
    }
  }

  if (item == "open") {
    volumeButton.setAttribute("aria-label", "Mute and Expand Video");
  } else {
    volumeButton.setAttribute("aria-label", "unMute and Expand Video");
  }
  if (item == "open") {
    Howitwork.unMute();
    Howitwork.playVideo();
    document.body.style.overflow = "hidden";
    volumeButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-x"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
  } else {
    var overlay = document.querySelector(".overlay");
    // var close = document.getElementById("close-button-howitwork"); //already defined
    close.style.display = "none";
    overlay.style.visibility = "hidden";
    Howitwork.mute();
    Howitwork.pauseVideo();
    Howitwork.seekTo(0);
    var navbar = document.getElementById("maf-global-navbar");
    navbar.style.zIndex = "99999";
    open = false; //eslint-disable-line
    document.body.style.overflow = "scroll";
    volumeButton.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>';
  }
}

function toggleVolumebutton() {
  //eslint-disable-line
  volumeButtonClick = true;
  var volumeButtonNav = document.getElementById("volume-button-howitwork");
  if (Howitwork.isMuted()) {
    Howitwork.unMute();
    Howitwork.playVideo();
    volumeButtonNav.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-x"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
  } else {
    Howitwork.mute();
    volumeButtonNav.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>';
  }
}

window.addEventListener("resize", function (e) {
  var isMobileView = window.innerWidth <= 960;
  var videoId = document.getElementById("video-container-howitwork");
  if (isMobileView) {
    videoId.style.top = "0";
    videoId.style.width = "100%";
    videoId.style.height = "100%";
    videoId.style.left = "0";
    videoId.style.transform = "translate(0%, 0%)";
    videoId.style.marginTop = "0px";
  } else {
    var videoWidth = window.innerWidth >= 1260;
    var videoHeight = window.innerHeight >= 800;
    videoId.style.marginTop = "20px";
    videoId.style.top = "50%";
    videoId.style.left = "50%";
    videoId.style.transform = "translate(-50%, -50%)";
    if (videoWidth && videoHeight) {
      videoId.style.top = "50%";
      videoId.style.left = "50%";
      videoId.style.width = "1176px";
      videoId.style.height = "662px";
    } else {
      var videoWidth = 1176; // Width of the video
      var videoHeight = 662; // Height of the video
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // Calculate the aspect ratio of the video
      var aspectRatio = videoWidth / videoHeight;

      let newWidth, newHeight;

      // Determine the maximum dimensions based on covering 80% of the screen
      var maxScreenWidth = windowWidth * 0.6;
      var maxScreenHeight = windowHeight * 0.6;

      // Determine which dimension (width or height) needs to be adjusted
      if (maxScreenWidth / maxScreenHeight > aspectRatio) {
        // Adjust based on width
        newWidth = Math.min(maxScreenWidth, videoWidth);
        newHeight = newWidth / aspectRatio;
      } else {
        // Adjust based on height
        newHeight = Math.min(maxScreenHeight, videoHeight);
        newWidth = newHeight * aspectRatio;
      }

      // Ensure the dimensions do not exceed the original video dimensions
      newWidth = Math.min(newWidth, videoWidth);
      newHeight = Math.min(newHeight, videoHeight);

      videoId.style.width = newWidth + "px";
      videoId.style.height = newHeight + "px";
    }
  }
});

document.addEventListener("click", function (event) {
  var video = document.getElementById("d-howitwork");
  var videoMobile = document.getElementById("maf-sidebar-howitworks");
  var volumeButtonNav = document.getElementById("overlay-video");
  if (event.target == volumeButtonNav) {
    volumeButtonClick = false;
  }
  // Check if the clicked element is not the video
  if (
    event.target !== video &&
    event.target !== videoMobile &&
    !video.contains(event.target) &&
    !videoMobile.contains(event.target)
  ) {
    // Close the video or take any action you want
    if (open && !volumeButtonClick) {
      toggleVolumeHowitwork("close");
      document.getElementById("d-howitwork").style.backgroundColor = "unset";
      var navbar = document.getElementById("maf-global-navbar");
      navbar.style.backgroundColor = "unset";
      navbar.style.zIndex = "99999";
    }
  }
});

